import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCampaign = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 14,
	fill: "none",
	viewBox: "0 0 16 14",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#49454F",
		d: "M7.7 8.4 0 4.2 7.7 0l7.7 4.2-7.7 4.2Zm0 2.8L.402 7.228l1.47-.805L7.7 9.607l5.827-3.184 1.47.804L7.7 11.2Zm0 2.8L.402 10.027l1.47-.804L7.7 12.407l5.827-3.184 1.47.804L7.7 14Z"
	})
});
export { SvgCampaign as ReactComponent };
